import { shape, string } from 'prop-types';
import multipleFiltersAttributesShape from './multipleFiltersAttributesShape';

export default shape({
    attributes: multipleFiltersAttributesShape,
    name: string,
    title: string,
    captionTitle: string,
    pictureUrl: string,
});
